import axiosInstance from '../../../shared/api/AxiosInstance';
import { fetchAllPagesVia } from '../../../shared/api/paginated';

export function createLastUserCompany(payload) {
    return axiosInstance.post('/businesses', payload);
}

export function listLastUserCompanies({ mine, scope, buyerMission }: { mine?: boolean; scope?: 'connect'; buyerMission?: boolean } = {}) {
    const params: Record<string, string> = {};
    if (mine) params.mine = 'true';
    if (scope) params.scope = scope;
    if (buyerMission) params.buyerMission = 'true';
    // FAZ 5 / F5-10 — uc sayfalandi; ekranda sayfalama arayuzu yok, tum
    // sayfalar cekiliyor. Cagiran sozlesmesi (`{ data: [...] }`) DEGISMIYOR.
    return fetchAllPagesVia(axiosInstance, '/businesses', params);
}

export function getLastUserCompany(companyId) {
    return axiosInstance.get(`/businesses/${companyId}`);
}

export function uploadLastUserCompanyLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/businesses/logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function uploadLastUserCompanyCover(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/businesses/cover', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function updateLastUserCompany(companyId, payload) {
    return axiosInstance.patch(`/businesses/${companyId}`, payload);
}

export function deleteLastUserCompany(companyId) {
    return axiosInstance.delete(`/businesses/${companyId}`);
}

export function createMeetingRequest(companyId, payload) {
    return axiosInstance.post(`/lastuser-companies/${companyId}/meeting-requests`, payload);
}

export function listCompanyComments(companyId) {
    return axiosInstance.get(`/lastuser-companies/${companyId}/comments`);
}

export function createCompanyComment(companyId, payload) {
    return axiosInstance.post(`/lastuser-companies/${companyId}/comments`, payload);
}

export function listMeetingRequests() {
    return axiosInstance.get('/lastuser-companies/meeting-requests');
}

export function createMeetingRequestMessage(requestId, payload) {
    return axiosInstance.post(`/lastuser-companies/meeting-requests/${requestId}/messages`, payload);
}

export function listConversations() {
    return axiosInstance.get('/lastuser-companies/messages');
}

export function listConversationMessages(conversationId) {
    return axiosInstance.get(`/lastuser-companies/messages/${conversationId}`);
}

export function sendConversationMessage(conversationId, payload) {
    return axiosInstance.post(`/lastuser-companies/messages/${conversationId}`, payload);
}

export function createDirectConversation(userId) {
    return axiosInstance.post(`/lastuser-companies/messages/users/${userId}`);
}

export function listBusinessDocuments(companyId) {
    return axiosInstance.get(`/businesses/${companyId}/documents`);
}
